// 首頁／遊戲分類頁、活動頁、VIP 頁的可見 SEO 文案（僅 theme_gold）
// 文案與 scripts/generate-seo-pages.js 共用 public/seo-meta.json，以網址上的 seo_path 為 key（區分大小寫），
// 不依賴 API 分類資料，API 失敗時照樣可渲染
// 其他主題打包時條件為常數 false，require 不會被打包，bundle 內不含 katsuwin 文案
const seoMeta = process.env.VUE_APP_THEME === 'theme_gold' ? require('../../public/seo-meta.json') : null

// seo_path → seo-meta.json 的 home 子 key；多個 key 表示文案合併（舊 pachinko、pachislot 已併為 pachinko-pachislot）
// slot 已無對應分類，保留網址顯示首頁大廳＋文案（見 views/index.vue isSeoOnlyPath）
const SEO_PATH_KEYS = {
  '': { keys: ['default'] },
  'Recommend': { keys: ['recommend'] },
  'new-game': { keys: ['new'] },
  'popular-games': { keys: ['popular'] },
  'live-casino': { keys: ['live_casino'] },
  'pachinko-pachislot': { keys: ['pachinko', 'pachislot'], name: 'パチンコ・パチスロ' },
  'crash': { keys: ['crash'] },
  'Sports': { keys: ['sport'] },
  'slot': { keys: ['slot'] }
}

// seo-meta.json 的分類 h1 為 [站名關鍵字, 分類名] 兩段，頁面只能有一個 h1，合併輸出
function joinH1(h1) {
  return Array.isArray(h1) ? h1.join('｜') : h1
}

function buildContent(pages, name) {
  if (pages.length === 0) return null

  const single = pages.length === 1 ? pages[0] : null
  const firstH1 = pages[0].h1
  const h1 = name && Array.isArray(firstH1)
    ? joinH1([firstH1[0], name])
    : joinH1(firstH1)

  return {
    h1,
    sections: pages.reduce((list, page) => list.concat(page.sections || []), []),
    title: single ? single.title : null,
    description: single ? single.description : null,
    keywords: single ? single.keywords : null
  }
}

// 首頁／分類頁：回傳 { h1, sections, title, description, keywords }；合併多組文案時 title／description 沒有定稿，回傳 null 交給頁面預設值
export function getCategorySeoContent(seoPath) {
  const entry = seoMeta && SEO_PATH_KEYS[seoPath || '']
  if (!entry) return null

  return buildContent(entry.keys.map(key => seoMeta.home[key]).filter(Boolean), entry.name)
}

// 獨立頁面（活動 event、VIP vip）：seo-meta.json 最外層同名 key，格式同上
export function getPageSeoContent(page) {
  if (!seoMeta || !['event', 'vip'].includes(page) || !seoMeta[page]) return null

  return buildContent([seoMeta[page]])
}
